import * as Sentry from "@sentry/react";
import Friends from "../../services/api/friend";
import { ROUTES } from "../../utils/constants";
import {
  SET_SELECTED_PENDING_TRANSFER_FRIEND_REMARKS,
  INITIATE_PENDING_TRANSFER_FRIEND_DATA,
} from "../actionTypes/dashboard";

export const transferFriend = async (dispatch, friendData, id, navigate) => {
  try {
    await Friends.transferFriend({
      data: friendData,
      friendId: id,
    });
    navigate(ROUTES.FRIEND_SEARCH.path);
  } catch (err) {
    alert(err.message || "Something went wrong. Please contact support.");
    Sentry.captureException(err);
  }
};
export const forwardFriend = async (
  payload,
  friendData,
  navigate,
  setShowToast
) => {
  try {
    await Friends.forwardFriend({
      friendId: friendData.id,
      transferRequestId: friendData.transferId,
    });
    setShowToast({
      message: "Successfully forward!",
      severity: "success",
    });
    setTimeout(() => {
      navigate(`/${ROUTES.FRIEND_TRANSFER.path}`);
    }, 2000);
  } catch (err) {
    setShowToast({
      message: err.message || "Something went wrong. Please contact support.",
      severity: "error",
    });
    Sentry.captureException(err);
  }
};

export const acceptFriend = async (
  payload,
  selectedFriend,
  navigate,
  setShowToast
) => {
  // console.log("LOG", { data, id, navigate });
  try {
    await Friends.acceptFriend({
      friendId: selectedFriend.id,
      transferId: selectedFriend.transferId,
      blockId: payload.blockId,
    });
    setShowToast({
      message: "Successfully Accepted!",
      severity: "success",
    });
    setTimeout(() => {
      navigate(`/${ROUTES.FRIEND_TRANSFER}`);
    }, 2000);
  } catch (err) {
    setShowToast({
      message: err.message || "Something went wrong. Please contact support.",
      severity: "error",
    });
    Sentry.captureException(err);
  }
};
export const rejectFriend = async (
  dispatch,
  payload,
  friendData,
  navigate,
  setShowToast
) => {
  try {
    await Friends.rejectFriend({
      data: { reason: { data: payload } },
      friendId: friendData.friendId,
      transferRequestId: friendData.transferId,
    });
    setShowToast({
      message: "Successfully Rejected!",
      severity: "success",
    });
    setTimeout(() => {
      navigate("/friend/transfered");
    }, 2000);
  } catch (err) {
    setShowToast({
      message: err.message || "Something went wrong. Please contact support.",
      severity: "error",
    });
    Sentry.captureException(err);
  }
};

export const fetchTransferFriendRemarksData = async (dispatch, introId) => {
  const result = await Friends.getFriendRemarks({
    id: introId,
  });

  dispatch({
    type: SET_SELECTED_PENDING_TRANSFER_FRIEND_REMARKS,
    payload: result.data,
  });
};

// eslint-disable-next-line import/prefer-default-export
export const fetchFriendTransferData = async (dispatch, type) => {
  dispatch({
    type: INITIATE_PENDING_TRANSFER_FRIEND_DATA,
    payload: {
      pageNumber: 0,
      pageSize: 5,
      type,
    },
  });
};
